import React from 'react';

import { Popover } from '@mui/material';

import { classes } from '../styles';

import type { Dispatch } from 'react';

import type {
  GenericTableData,
  TableActionItemAction,
  TSortableColumn,
  TTableState
} from '../types';

interface IOption {
  id: string;
  label: string;
  action: () => void;
}

const MoreOptionsList = ({
  options,
  actionsState,
  dispatch,
  label
}: {
  options: IOption[];
  actionsState: TTableState<GenericTableData, TSortableColumn>['actions'];
  dispatch: Dispatch<TableActionItemAction<GenericTableData>>;
  label: string;
}) => {
  const handleSelectItem = (action: () => void) => {
    dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'moreOptions' });
    action();
  };
  return (
    <Popover
      anchorEl={actionsState?.anchorEl}
      id={`${label}-more-options-popover`}
      onClose={() => dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'moreOptions' })}
      open={actionsState?.isOpen?.moreOptions}
      sx={classes.actionsMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      {options.map((option) => (
        <span
          key={option.id}
          className={`${option.id}-action-button`}
          onClick={() => handleSelectItem(option.action)}
        >
          {option.label}
        </span>
      ))}
    </Popover>
  );
};

export default MoreOptionsList;
